/** LAYOUT
 * @param ID 對應後端 fetch layout 的 ID
 * @param NAME 對應 layout 在前端的 redux reducer 名稱與該  API 在 redux 狀態的名稱
 */
export const LAYOUT = {
  EXPERT_LIST: {
    ID: 'expert_list',
    NAME: 'expertList'
  },
  POPULAR_POI: {
    ID: 'popular_poi',
    NAME: 'popularPoiList'
  },
  POPULAR_ITINERARY: {
    ID: 'popular_itinerary',
    NAME: 'popularItineraryList'
  },
  FEATURE_LIST: {
    ID: 'feature_list',
    NAME: 'featureList'
  },
  FOLLOWING: {
    ID: 'following',
    NAME: 'following'
  },
  POPULAR_JOURNAL: {
    ID: 'popular_journal',
    NAME: 'popularJournalList'
  },
  LATEST_JOURNAL: {
    ID: 'latest_journal',
    NAME: 'latestJournalList'
  },
  PRODUCT_LIST: {
    ID: 'product_list',
    NAME: 'productList'
  },
  PRODUCT_BANNER: {
    ID: 'product_banner',
    NAME: 'productBanner'
  },
  CITY: {
    ID: 'city',
    NAME: 'city'
  },
  TOPIC: {
    ID: `topic${process.env.REACT_APP_TOPIC_CATEGORY_01}`,
    NAME: 'topicCarousel'
  },
  FUTURE_COUNT: {
    ID: 'future_count',
    NAME: 'futureCount'
  },
  ACTION_BUTTONS: {
    ID: 'action_buttons',
    NAME: 'actionButtons'
  }
};
